//Short addresses that always point at the CURRENT page of a recurring event, e.g.
//learning.clubwealth.com/bsm -> /bsm2026. Decided here in code, on purpose, not in the Page
//Builder (Omerson 09/25/2026): a page's url in the builder is its permanent address, and
//nobody has to remember to move "/bsm" from last year's page to this year's.
//
//Each year: point the alias at the new page's url. The alias itself must NOT be any page's
//url in the Page Builder (it would be unreachable); last year's /bsm page was moved to
///bsm2020-archive for that reason (tasks/agenda-page/agenda-bsm2026/migrations/012).
//
//The ?query and the #anchor are kept, so /bsm#tue-0930 lands on the Tuesday 9:30 row
//(pageAnchors.js) and tracking parameters (utm_*) survive.
//
//A target may also be a full address on ANOTHER site ("https://..."). Then the visitor leaves
//the app: the ?query is kept (tracking), the #anchor is dropped (it named a row of our page).
//
//09/30/2026 (Omerson): the BSM 2026 agenda was hidden from customers while the bosses reviewed
//it (/bsm and /bsm2026 went to https://clubwealth.com/bsm, the agenda lived at /bsm/preview).
//10/20/2026 (Omerson): published again. The page is back at /bsm2026
//(tasks/agenda-page/agenda-bsm2026/migrations/015's down file) and /bsm points at it.
///bsm/preview, the address the bosses reviewed it at, now has no page of its own, so it points
//at /bsm2026 too and their saved links keep working.
export const CURRENT_PAGE_ALIASES = {
  '/bsm': '/bsm2026',
  '/bsm/preview': '/bsm2026'
};

//True when an alias target is on another site, so it needs a real page load, not a route change.
export const isExternalTarget = (target) => /^https?:\/\//i.test(target || '');

//"/BSM/" -> "/bsm". Page urls are matched case-insensitively by the backend (latin1 _ci
//column), so the alias is too, and a trailing slash is ignored.
const normalise = (pathname) =>
  (pathname || '').toLowerCase().replace(/\/+$/, '') || '/';

//The page an alias points at, or undefined when `pathname` is not an alias.
export const resolvePageAlias = (pathname) => {
  const target = CURRENT_PAGE_ALIASES[normalise(pathname)];
  return target && normalise(target) !== normalise(pathname)
    ? target
    : undefined;
};

//The full address to go to instead of `location` (target + ?query + #anchor), or
//undefined when no redirect is needed.
export const aliasRedirectTarget = (location) => {
  const target = resolvePageAlias(location?.pathname);
  if (!target) return undefined;
  if (isExternalTarget(target)) return target + (location.search || '');
  return target + (location.search || '') + (location.hash || '');
};
